module.exports = __webpack_public_path__ + "static/media/iguazu-falls-10.e105492a.jpg";